import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms"
import { LoginRequest } from "./login-request"

export class LoginForm extends UntypedFormGroup{
    constructor(){
     super({
         'username' : new UntypedFormControl("",[
            Validators.required,
         ]

         ),
         'password' : new UntypedFormControl("",[
            Validators.required,
         ]
        ),
        "unauthorized": new UntypedFormControl(false,[]) 
     })
    }

    public buildUser(): LoginRequest{
        return {
            username: this.value.username,
            password: this.value.password
        }
    }
}
